"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var icons_material_1 = require("@mui/icons-material");
var material_1 = require("@mui/material");
var IconButton_1 = __importDefault(require("../buttons/IconButton"));
var BaseStyledDialog_1 = __importDefault(require("./BaseStyledDialog"));
var StepperDialog = function (props) {
    return (react_1.default.createElement(BaseStyledDialog_1.default, { maxWidth: 'md', open: props.open, onClose: props.handleCancel },
        react_1.default.createElement(material_1.DialogTitle, { id: "form-dialog-title", color: "primary", variant: "h3" },
            react_1.default.createElement(material_1.Box, { py: 1, display: "flex" },
                props.title,
                react_1.default.createElement(material_1.Box, { flexGrow: 1 }),
                react_1.default.createElement(IconButton_1.default, { size: "small", color: "error", onClick: props.handleCloseClicked },
                    react_1.default.createElement(icons_material_1.Close, null)))),
        react_1.default.createElement(material_1.DialogContent, null,
            react_1.default.createElement(material_1.Box, { pb: 3 }, props.stepper),
            props.children),
        react_1.default.createElement(material_1.DialogActions, null,
            react_1.default.createElement(material_1.Box, { display: "flex", flexDirection: "column", flexGrow: 1 },
                react_1.default.createElement(material_1.Box, { display: "flex" },
                    react_1.default.createElement(material_1.Box, { flexGrow: 1 }),
                    react_1.default.createElement(material_1.Box, null,
                        react_1.default.createElement(material_1.Button, { color: "inherit", variant: "outlined", disabled: props.hasPrevious, onClick: props.handleBack, sx: { mr: 1 } }, "Back"),
                        props.canSave ?
                            react_1.default.createElement(material_1.Button, { type: "submit", color: "primary", variant: "contained", onClick: props.handleSave }, "Save")
                            :
                                react_1.default.createElement(material_1.Button, { onClick: props.handleNext, variant: "outlined" }, "Next")))))));
};
exports.default = StepperDialog;
